import { CancelToken } from 'axios';
import { awBridgeApi } from '../Base';
import { ResolvableSecurityRequest, ResolvableSecurityResponse } from './types';

const BASE_SECURITY_PATH = 'v1/security/get';

export function postResolveAndGetSecurities(
  resolvableSecurityRequest: ResolvableSecurityRequest,
  date: string,
  pkg: string,
  cancelToken?: CancelToken
) {
  return awBridgeApi.post<ResolvableSecurityResponse>(`${BASE_SECURITY_PATH}:resolve`, resolvableSecurityRequest, {
    params: { pkg, date },
    cancelToken,
  });
}
